/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TGetStorageReportResponse } from '../models/TGetStorageReportResponse';
import type { TGroupId } from '../models/TGroupId';
import type { TListStoredFilesResponse } from '../models/TListStoredFilesResponse';
import type { TSetStoragePacksRequest } from '../models/TSetStoragePacksRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StorageService {
    /**
     * Get an account's storage: the meter's figures, the breakdown by category, and each project's share
     * @param groupId
     * @returns TGetStorageReportResponse TGetStorageReportResponse
     * @throws ApiError
     */
    public static getStorageReport(
        groupId: TGroupId,
    ): CancelablePromise<TGetStorageReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/storage/{group_id}',
            path: {
                'group_id': groupId,
            },
        });
    }
    /**
     * List every asset and document an account stores, largest first
     * @param groupId
     * @returns TListStoredFilesResponse TListStoredFilesResponse
     * @throws ApiError
     */
    public static listStoredFiles(
        groupId: TGroupId,
    ): CancelablePromise<TListStoredFilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/storage/{group_id}/files',
            path: {
                'group_id': groupId,
            },
        });
    }
    /**
     * Set how many storage packs the account's subscription carries (the account's owner, or a Talon
     * admin). Billed, prorated, to the payment method on file.
     * @param groupId
     * @param requestBody
     * @returns TGetStorageReportResponse TGetStorageReportResponse
     * @throws ApiError
     */
    public static setStoragePacks(
        groupId: TGroupId,
        requestBody: TSetStoragePacksRequest,
    ): CancelablePromise<TGetStorageReportResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/storage/{group_id}/packs',
            path: {
                'group_id': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
